import React from 'react';
import type { RttsGateFields, RttsUserRole } from '../types';
import { formatGameContext } from '../lib/formatGameContext';
import RunTheTapeButton from './RunTheTapeButton';

export type GameRowProps = {
  leagueId: string;
  gates: RttsGateFields;
  userRole: RttsUserRole;
  onJobStarted?: (jobId: string) => void;
};

function formatPlayedAt(value: string): string {
  try {
    return new Date(value).toLocaleString();
  } catch {
    return value;
  }
}

const GameRow: React.FC<GameRowProps> = ({
  leagueId,
  gates,
  userRole,
  onJobStarted,
}) => {
  const context = formatGameContext(gates);

  return (
    <div
      className="flex flex-col gap-3 rounded-xl border border-secondary-700 bg-secondary-800/40 px-4 py-3"
      data-testid="rtts-game-row"
      data-archive-id={gates.archive_id}
    >
      <div className="min-w-0">
        <p className="text-sm font-medium text-white truncate">{gates.matchup}</p>
        {context ? (
          <p className="text-xs text-secondary-400 mt-0.5" data-testid="rtts-game-context">
            {context}
          </p>
        ) : null}
        {gates.played_at ? (
          <p className="text-xs text-secondary-500 mt-0.5" data-testid="rtts-game-played-at">
            {formatPlayedAt(gates.played_at)}
          </p>
        ) : null}
      </div>
      <div className="w-full max-w-full min-w-0">
        <RunTheTapeButton
          leagueId={leagueId}
          gates={gates}
          userRole={userRole}
          onJobStarted={onJobStarted}
        />
      </div>
    </div>
  );
};

export default GameRow;
